import axios from "axios";

const endPoint =
  process.env.REACT_APP_API_URL || new URL(window.location.href).origin;

axios.interceptors.request.use(
  function (config) {
    const { origin } = new URL(config.url);
    const allowedOrigins = [endPoint];
    const token = localStorage.getItem("access-token");

    if (allowedOrigins.includes(origin)) {
      config.headers.authorization = token;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export const fetchLogin = async (email, password) => {
  const { data } = await axios.post(`${endPoint}/api/auth/login`, {
    email,
    password,
  });
  return data;
};

export const fetchMe = async () => {
  const { data } = await axios.get(`${endPoint}/api/auth/me`);
  return data;
};

export const refreshToken = async (token) => {
  const { data } = await axios.post(`${endPoint}/api/auth/refreshtoken`, {
    refreshToken: token,
  });
  return data;
};

export const fetchData = async (table, pager, page, filterString) => {
  const { data } = await axios.get(
    `${endPoint}/api/${table}?limit=${pager.pageSize}&page=${page}${
      filterString.length > 0 ? `&filter=[${filterString}]` : ""
    }`
  );
  return data;
};

export const getRegions = async () => {
  const { data } = await axios.get(`${endPoint}/api/regions`);
  return data;
};

export const addRegions = async (values) => {
  const { data } = await axios.post(`${endPoint}/api/regions`, values);
  return data;
};

export const updateRegion = async ({ id, values }) => {
  const { data } = await axios.post(
    `${endPoint}/api/regions/update/${id}`,
    values
  );
  return data;
};

export const removeRegion = async (id) => {
  const { data } = await axios.get(`${endPoint}/api/regions/delete/${id}`);
  return data;
};

export const userRegister = async (values) => {
  const { data } = await axios.post(`${endPoint}/api/auth/register`, values);
  return data;
};

export const getAccountInfo = async (code) => {
  const { data } = await axios.get(`${endPoint}/api/accounts/${code}`);
  return data;
};

export const removeUser = async (id) => {
  const { data } = await axios.get(`${endPoint}/api/users/delete/${id}`);
  return data;
};

export const updateUser = async ({ id, values }) => {
  const { data } = await axios.post(
    `${endPoint}/api/users/update/${id}`,
    values
  );
  return data;
};

export const fetchUser = async (id) => {
  const { data } = await axios.get(`${endPoint}/api/users/${id}`);
  return data;
};

export const addOrder = async (values) => {
  const { data } = await axios.post(`${endPoint}/api/orders/create`, values);
  return data;
};

export const approveOrder = async (id, note) => {
  const { data } = await axios.post(`${endPoint}/api/orders/approve/${id}`, {
    responseNote: note,
  });
  return data;
};

export const rejectOrder = async (id, note) => {
  const { data } = await axios.post(`${endPoint}/api/orders/reject/${id}`, {
    responseNote: note,
  });
  return data;
};

export const exportOrders = async (ids) => {
  const { data } = await axios.post(`${endPoint}/api/orders/export`, {
    ordersIdList: ids,
  });
  return data;
};

export const ordermailInfo = async (id) => {
  const { data } = await axios.get(
    `${endPoint}/api/orders/orderinfomail/${id}`
  );
  return data;
};

export const pendingOrders = async () => {
  const { data } = await axios.get(
    `${endPoint}/api/orders?filter=[status:pending:same]`
  );
  return data;
};

export const outStock = async () => {
  const { data } = await axios.get(`${endPoint}/api/products/outstock`);
  return data;
};

export const countProducts = async () => {
  const { data } = await axios.get(`${endPoint}/api/products/count`);
  return data;
};

export const countCustomers = async () => {
  const { data } = await axios.get(`${endPoint}/api/customers/count`);
  return data;
};

export const countOrders = async () => {
  const { data } = await axios.get(`${endPoint}/api/orders/count`);
  return data;
};

export const updateCustomer = async (id, values) => {
  const { data } = await axios.post(
    `${endPoint}/api/customers/update/${id}`,
    values
  );
  return data;
};

export const changePassword = async (values) => {
  const { data } = await axios.post(
    `${endPoint}/api/auth/changepassword`,
    values
  );
  return data;
};

export const resetPassword = async (values) => {
  const { data } = await axios.post(`${endPoint}/api/auth/forgotpass`, values);
  return data;
};

export const getSettings = async () => {
  const { data } = await axios.get(`${endPoint}/api/settings`);
  return data;
};

export const updateSettings = async (key, values) => {
  const { data } = await axios.post(
    `${endPoint}/api/settings/update?key=${key}`,
    values
  );
  return data;
};

export const getTemps = async () => {
  const { data } = await axios.get(`${endPoint}/api/mailtemps`);
  return data;
};

export const updateTemps = async (key, values) => {
  const { data } = await axios.post(
    `${endPoint}/api/mailtemps/update?key=${key}`,
    values
  );
  return data;
};

export const exportedOrders = async (ids) => {
  const { data } = await axios.post(`${endPoint}/api/orders/exported`, {
    ordersIdList: ids,
  });
  return data;
};

export const exportOrdersToMicro = async (endpoint, values) => {
  const { data } = await axios.post(endpoint, values);
  return data;
};
